import React from 'react';
const SLOTS = [
  { time: '8–10 AM', delivery: 2, pickup: 3, deliveryMax: 4, pickupMax: 6 },
  { time: '10 AM–12 PM', delivery: 4, pickup: 5, deliveryMax: 4, pickupMax: 6 },
  { time: '12–2 PM', delivery: 3, pickup: 4, deliveryMax: 4, pickupMax: 6 },
  { time: '2–4 PM', delivery: 1, pickup: 2, deliveryMax: 4, pickupMax: 6 },
  { time: '4–6 PM', delivery: 0, pickup: 1, deliveryMax: 4, pickupMax: 6 },
  { time: '6–8 PM', delivery: 0, pickup: 0, deliveryMax: 4, pickupMax: 6 },
];
const DRIVERS = [
  { name: 'Carlos M.', vehicle: 'Van #1', status: 'En Route', deliveries: 3, completed: 1, eta: '12:45 PM' },
  { name: 'Jenny W.', vehicle: 'Van #2', status: 'Loading', deliveries: 2, completed: 0, eta: '1:15 PM' },
  { name: 'Pat S.', vehicle: 'Van #3', status: 'Available', deliveries: 0, completed: 4, eta: '—' },
];
const DSC = { 'En Route': '#3B82F6', Loading: '#F59E0B', Available: '#16A34A', 'Off Duty': '#94A3B8' };
export default function DeliveryPickupPage() {
  const totalDel = SLOTS.reduce((a, s) => a + s.delivery, 0);
  const totalPick = SLOTS.reduce((a, s) => a + s.pickup, 0);
  return (
    <div className="page-body" style={{ padding: 24 }}>
      <div style={{ marginBottom: 24 }}>
        <h1 style={{ color: 'var(--text)', fontSize: 26, fontWeight: 700, margin: '0 0 4px' }}>Delivery & Pickup</h1>
        <p style={{ color: 'var(--text-muted)', fontSize: 14, margin: 0 }}>Time slot management, drivers, and fulfillment</p>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 16, marginBottom: 24 }}>
        {[{ label: 'Deliveries Today', value: totalDel, color: '#8B5CF6' }, { label: 'Pickups Today', value: totalPick, color: '#F97316' }, { label: 'Active Drivers', value: DRIVERS.filter(d => d.status !== 'Available' && d.status !== 'Off Duty').length, color: '#3B82F6' }].map((s, i) => (
          <div key={i} style={{ padding: 20, background: 'var(--card)', borderRadius: 12, border: '1px solid var(--border)' }}>
            <div style={{ color: 'var(--text-muted)', fontSize: 11, fontWeight: 600, textTransform: 'uppercase', marginBottom: 8 }}>{s.label}</div>
            <div style={{ color: s.color, fontSize: 24, fontWeight: 700 }}>{s.value}</div>
          </div>
        ))}
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
        <div style={{ background: 'var(--card)', borderRadius: 12, border: '1px solid var(--border)', overflow: 'auto' }}>
          <div style={{ padding: '16px 16px 0', color: 'var(--text)', fontSize: 14, fontWeight: 700 }}>Time Slots</div>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead><tr>{['Slot', 'Delivery', 'Pickup'].map(h => (
              <th key={h} style={{ padding: '10px 16px', textAlign: 'left', fontSize: 11, fontWeight: 600, textTransform: 'uppercase', color: 'var(--text-muted)', borderBottom: '1px solid var(--border)' }}>{h}</th>
            ))}</tr></thead>
            <tbody>{SLOTS.map(s => (
              <tr key={s.time} style={{ borderBottom: '1px solid var(--border)' }}>
                <td style={{ padding: '10px 16px', color: 'var(--text)', fontSize: 13, fontWeight: 600 }}>{s.time}</td>
                <td style={{ padding: '10px 16px' }}><span style={{ color: s.delivery >= s.deliveryMax ? '#EF4444' : '#16A34A', fontSize: 13, fontWeight: 600 }}>{s.delivery}/{s.deliveryMax}</span></td>
                <td style={{ padding: '10px 16px' }}><span style={{ color: s.pickup >= s.pickupMax ? '#EF4444' : '#16A34A', fontSize: 13, fontWeight: 600 }}>{s.pickup}/{s.pickupMax}</span></td>
              </tr>
            ))}</tbody>
          </table>
        </div>
        <div style={{ background: 'var(--card)', borderRadius: 12, border: '1px solid var(--border)', overflow: 'auto' }}>
          <div style={{ padding: '16px 16px 0', color: 'var(--text)', fontSize: 14, fontWeight: 700 }}>Drivers</div>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead><tr>{['Driver', 'Vehicle', 'Deliveries', 'ETA', 'Status'].map(h => (
              <th key={h} style={{ padding: '10px 16px', textAlign: 'left', fontSize: 11, fontWeight: 600, textTransform: 'uppercase', color: 'var(--text-muted)', borderBottom: '1px solid var(--border)' }}>{h}</th>
            ))}</tr></thead>
            <tbody>{DRIVERS.map(d => (
              <tr key={d.name} style={{ borderBottom: '1px solid var(--border)' }}>
                <td style={{ padding: '10px 16px', color: 'var(--text)', fontSize: 13, fontWeight: 600 }}>{d.name}</td>
                <td style={{ padding: '10px 16px', color: 'var(--text-muted)', fontSize: 12 }}>{d.vehicle}</td>
                <td style={{ padding: '10px 16px', color: 'var(--text)', fontSize: 13 }}>{d.completed}/{d.deliveries + d.completed}</td>
                <td style={{ padding: '10px 16px', color: 'var(--text-muted)', fontSize: 12 }}>{d.eta}</td>
                <td style={{ padding: '10px 16px' }}><span style={{ padding: '3px 10px', borderRadius: 12, fontSize: 11, fontWeight: 600, background: `${DSC[d.status]}20`, color: DSC[d.status] }}>{d.status}</span></td>
              </tr>
            ))}</tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
